"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _PageTitle = _interopRequireDefault(require("../TitlesAndTexts/PageTitle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
// Components
const LocalMenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "LocalMenu__LocalMenuWrapper",
  componentId: "design-system__sc-1hmix9f-0"
})(["box-sizing:border-box;border-bottom:1px solid ", ";height:3.5rem;display:grid;grid-template-columns:56px 182px auto 180px minmax(144px,10%);position:sticky;align-items:center;z-index:11;& > *{box-sizing:border-box;}& > h2{grid-column-start:2;}& > a{border:black;justify-self:end;}"], _BaseTheme.default.colors.lightgray);

const LocalMenu = _ref => {
  let {
    pageTitle,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(LocalMenuWrapper, {
    className: "localmenu"
  }, /*#__PURE__*/_react.default.createElement(_PageTitle.default, null, pageTitle), children);
};

LocalMenu.propTypes = {
  pageTitle: _propTypes.default.string.isRequired,
  children: _propTypes.default.node
};
LocalMenu.defaultProps = {
  children: null
};
var _default = LocalMenu;
exports.default = _default;